import { render, staticRenderFns } from "./FolderTreeItem.vue?vue&type=template&id=524664a0&"
import script from "./FolderTreeItem.vue?vue&type=script&lang=js&"
export * from "./FolderTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./FolderTreeItem.vue?vue&type=style&index=0&id=524664a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports